import request from '@/utils/request'

// 获取资源概览数据
export function getResourceOverview() {
  return request({
    url: '/resources/overview',
    method: 'get'
  })
}

// 批量更新资源配额
export function batchUpdateResourceQuotas(data) {
  return request({
    url: '/resources/quotas/batch',
    method: 'put',
    data
  })
}

// 预览批量调整配额
export function previewBatchUpdateQuotas(data) {
  return request({
    url: '/resources/batch/preview',
    method: 'post',
    data
  })
}

// 执行批量调整配额
export function executeBatchUpdateQuotas(data) {
  return request({
    url: '/resources/batch/execute',
    method: 'post',
    data
  })
}

// 获取资源使用趋势数据
export function getResourceUsageTrend(params) {
  return request({
    url: '/resources/trend',
    method: 'get',
    params
  })
}

// 获取指定配额的使用趋势数据
export function getResourceQuotaUsageTrend(id, params) {
  return request({
    url: `/resources/quota-trend/${id}`,
    method: 'get',
    params
  })
}

// 获取资源配额列表
export function getResourceQuotas(params) {
  return request({
    url: '/resources/quotas',
    method: 'get',
    params
  })
}

// 分配资源配额
export function allocateResourceQuota(data) {
  return request({
    url: '/resources/allocate',
    method: 'post',
    data
  })
}

// 更新资源配额
export function updateResourceQuota(id, data) {
  return request({
    url: `/resources/quota/${id}`,
    method: 'put',
    data
  })
}

// 获取可用大模型列表
export function getAvailableModels(params) {
  return request({
    url: '/resources/models',
    method: 'get',
    params
  })
}

// 获取资源使用统计
export function getResourceUsage(params) {
  return request({
    url: '/resources/usage',
    method: 'get',
    params
  })
}

// 查询剩余资源量
export function getRemainingResources(params) {
  return request({
    url: '/resources/remaining',
    method: 'get',
    params
  })
}

// 删除资源配额
export function deleteResourceQuota(id) {
  return request({
    url: `/resources/quota/${id}`,
    method: 'delete'
  })
}

// 批量删除资源配额
export function batchDeleteResourceQuotas(ids) {
  return request({
    url: '/resources/quotas',
    method: 'delete',
    data: ids
  })
}

// 获取资源配额详情
export function getResourceQuotaDetail(id) {
  return request({
    url: `/resources/quota/${id}`,
    method: 'get'
  })
}

// 获取资源使用明细
export function getResourceUsageDetails(params) {
  return request({
    url: '/resources/usage-details',
    method: 'get',
    params
  })
}

// 获取用户列表
export function getUserList(params) {
  return request({
    url: '/user/list',
    method: 'get',
    params
  })
}

// 获取资源监控详细统计数据
export function getDetailedStats(params) {
  return request({
    url: '/resources/stats/detailed',
    method: 'get',
    params
  })
}

// 获取配额配置
export function getQuotaConfig() {
  return request({
    url: '/resource/quota-config',
    method: 'get'
  })
}

// 更新配额配置
export function updateQuotaConfig(data) {
  return request({
    url: '/resource/quota-config',
    method: 'put',
    data
  })
}

// 获取资源告警列表
export function getResourceAlerts(params) {
  return request({
    url: '/resources/alerts',
    method: 'get',
    params
  })
}

// 解决资源告警
export function resolveResourceAlert(id, remark) {
  return request({
    url: `/resources/alert/resolve/${id}`,
    method: 'post',
    data: { remark }
  })
}

// 忽略资源告警
export function ignoreResourceAlert(id) {
  return request({
    url: `/resources/alert/ignore/${id}`,
    method: 'post'
  })
}

// 手动触发资源预警检查
export function checkResourceAlerts() {
  return request({
    url: '/resources/alert/check',
    method: 'post'
  })
}

// 生成资源报表
export function generateResourceReport(params) {
  return request({
    url: '/resources/report',
    method: 'get',
    params
  })
}

// 导出资源报表
export function exportResourceReport(params) {
  return request({
    url: '/resources/report/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// 导出资源配额列表
export function exportResourceQuotas(params) {
  return request({
    url: '/resources/quotas/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// 更新资源配额状态
export function updateResourceQuotaStatus(id, status) {
  return request({
    url: `/resources/quota/${id}/status`,
    method: 'put',
    data: { status }
  })
}

// 获取配额策略分页列表
export function getQuotaPolicies(params) {
  return request({
    url: '/quota/policies/page',
    method: 'get',
    params
  })
}

// 获取配额策略详情
export function getQuotaPolicy(id) {
  return request({
    url: `/quota/policies/${id}`,
    method: 'get'
  })
}

// 保存配额策略
export function saveQuotaPolicy(data) {
  return request({
    url: '/quota/policies',
    method: 'post',
    data
  })
}

// 修改配额策略
export function updateQuotaPolicy(data) {
  return request({
    url: '/quota/policies',
    method: 'put',
    data
  })
}

// 批量删除配额策略
export function deleteQuotaPolicies(ids) {
  return request({
    url: '/quota/policies',
    method: 'delete',
    data: ids
  })
}

// 获取额度审计流水
export function getQuotaTransactions(params) {
  return request({
    url: '/resources/transactions',
    method: 'get',
    params
  })
}

// 导出额度审计流水
export function exportTransactions(params) {
  return request({
    url: '/resources/transactions/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// 导出使用明细
export function exportUsageLogs(params) {
  return request({
    url: '/resources/usage-logs/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}